export default __webpack_public_path__ + "static/media/selling-thumb-v1.81bd93e9.webp";